// Builds storefront (Shopify) auth URLs. Shopify only allows internal
// redirects, so return_to must be a Shopify-internal path that bounces
// back to the stylist app.

const storeUrl = () => process.env.VUE_APP_FASHIONPHILE_ONLINE_STORE_URL || ''
const returnTo = () => process.env.VUE_APP_LOGIN_RETURN_TO_PATH || ''

export function loginUrl () {
  const loginPath = process.env.VUE_APP_LOGIN_PATH || ''
  const baseReturnTo = returnTo()
  const search = window.location.search || ''
  const separator = baseReturnTo.includes('?') ? '&' : '?'
  const fullReturnTo = search ? `${baseReturnTo}${separator}${search.slice(1)}` : baseReturnTo
  return `${storeUrl()}${loginPath}?return_to=${encodeURIComponent(fullReturnTo)}`
}

export function logoutUrl () {
  const accountUrl = process.env.VUE_APP_FASHIONPHILE_ACCOUNT_URL || ''
  const logoutPath = process.env.VUE_APP_LOGOUT_PATH || ''
  const logoutReturnTo = process.env.VUE_APP_LOGOUT_RETURN_TO_PATH || ''
  return `${accountUrl}${logoutPath}?return_url=${encodeURIComponent(logoutReturnTo)}`
}
